<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 14 14">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1">
			<path d="M10.336 1.45A4.9 4.9 0 0 1 12.152 3m.98 5.5q.117-.703.118-1.5c.001-.797-.04-1.032-.118-1.5m-.743 5.133C11.39 12.335 9.55 13.25 7 13.25C3 13.25.75 11 .75 7S3 .75 7 .75c.323.003 1.073.032 1.492.125" />
			<path d="M7 4.75v2.5l2.062 2.403" />
		</g>
	</svg>
</template>
